<script>
  import {mapState} from "vuex";

  export default {
    name: "GamePlayFooter",
    computed: {
      ...mapState(['questionCategoryId'])
    }
  }
</script>

<template>
  <div class="d-flex justify-content-center align-items-center col-12 position-absolute">
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="2" viewBox="0 0 36 2" fill="none">
      <path d="M0.970032 1.0011H35.1541" stroke="#000F56" stroke-opacity="0.18" stroke-width="0.727321"/>
    </svg>
    <img src="@/assets/gameplay/trivia-icon.png" class="col-1" />
    <div class="col-6" style="
color: rgba(0, 15, 86, 0.50);
text-align: center;
      font-size: 16px;
      font-weight: 700;
">
      {{questionCategoryId === 46 ? 'GUESS THE SONG' : 'MUSIC TRIVIA' }}
    </div>
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="2" viewBox="0 0 36 2" fill="none">
      <path d="M0.970032 1.0011H35.1541" stroke="#000F56" stroke-opacity="0.18" stroke-width="0.727321"/>
    </svg>
  </div>
</template>

<style scoped>

</style>